import React, {Fragment} from 'react';
import PropTypes from 'prop-types';

import Page from './Page';
import Translation from './Translation';

function renderItem({title, address, email, fax, mob, tel}, index) {
	return (
		<li className="slx-mounting-contacts__item" key={index}>
			<h3 className="slx-mounting-contacts__item-title">{title}</h3>
			<p
				className="slx-mounting-contacts__item-address"
				dangerouslySetInnerHTML={{__html: address}}
				/>
			{tel && <p><Translation name="tel" />: {tel}</p>}
			{mob && <p><Translation name="mob" />: {mob}</p>}
			{fax && <p><Translation name="fax" />: {fax}</p>}
			{email && <p><a href={`mailto:${email}`}><Translation name="email" />: {email}</a></p>}
		</li>
	);
}

function Contact({content, startPageNumber, maxPageNumber}) {
	const {contacts} = content;

	if (!contacts) {
		return null;
	}

	console.log('contacts', contacts);
	return (
		<Page
			content={content}
			number={startPageNumber}
			maxPageNumber={maxPageNumber}
		>
			<ul className="slx-mounting-contacts__list">
				{contacts.map(renderItem)}
			</ul>
		</Page>
	);
}

Contact.propTypes = {
	content: PropTypes.object.isRequired,
	startPageNumber: PropTypes.number.isRequired,
	maxPageNumber: PropTypes.number.isRequired,
};

export default React.memo(Contact);

export function numPages({content: {contacts}}) {
	return !!contacts | 0;
}
